import Stomp from "stompjs";
import SockJS from "sockjs-client";

class GlobalSocket {
  constructor(socketBaseUrl, connectOptions) {
    const isDevelopment = process.env.NODE_ENV === "development";

    this.socketUrl = isDevelopment
      ? "https://m.matpisa.com"
      : window.location.origin;
    this.sportSocketBaseUrl = socketBaseUrl;
    this.connectOptions = connectOptions;

    this.isConnected = false;
    this.reConnectCount = 0;
    this.timeout = null;

    this.instance = new SockJS(this.socketUrl + this.sportSocketBaseUrl);
    this.stompClient = Stomp.over(this.instance);
    this.stompClient.reconnect_delay = 3000;
    this.stompClient.debug = isDevelopment ? true : false;

    // 订阅的主题列表
    this.subscribeList = [];
  }

  async connect() {
    return new Promise((resolve, reject) => {
      this.stompClient.connect(
        this.connectOptions,
        resp => {
          clearTimeout(this.timeout);
          this.connectSuccess(resp);
          resolve(resp);
        },
        err => {
          this.connectFail(err);
          reject(err);
        }
      );
    });
  }

  disconnect() {
    this.stompClient.disconnect();
    this.subscribeList = [];
  }
  getSubscribeList() {
    console.log("this.subscribeList", this.subscribeList);
  }
  connectSuccess(frame) {
    this.isConnected = true;
    console.log(`SportSocket: 连接成功成功`);
  }

  connectFail(err) {
    this.isConnected = false;
    setTimeout(() => {
      console.log("连接socket失败, 正在重新连接...");
      this.connect();
    }, 1000);
  }

  subscribe(topic, callback) {
    if (!this.isConnected || this.subscribeList.includes(topic)) return;
    console.log(`订阅主题: ${topic}`);
    this.subscribeList.push(topic);
    this.stompClient.subscribe(
      topic,
      res => {
        let message = JSON.parse(res.body);
        callback && callback(message);
      },
      { id: topic }
    );
  }

  unsubscribe(topic) {
    console.log(`取消订阅主题: ${topic}`);

    const index = this.subscribeList.findIndex(elem => elem === topic);
    this.subscribeList.splice(index, 1);

    this.stompClient.unsubscribe(topic);
  }
  unsubscribeAll() {
    this.subscribeList.forEach(topic => {
      this.unsubscribe(topic);
    });
  }
};

export default GlobalSocket;


// WEBPACK FOOTER //
// ./src/common/utils/socket.js